import type { HTMLAttributes } from 'react';
import { clsx } from 'clsx';
import './ContentSurface.scss';

export interface IContentSurfaceProps extends HTMLAttributes<HTMLElement> {
    /** Семантический элемент контейнера. @default 'div' */
    component?: 'div' | 'section';
}

/** Остров содержимого: единые рамка, скругление и тень.
 * Фон, отступы, высоту и прокрутку задаёт страница — компонент не меняет её раскладку.
 */
const ContentSurface = ({ component: Component = 'div', className, ...props }: IContentSurfaceProps) => (
    <Component className={clsx('rf-content-surface', className)} {...props} />
);

export default ContentSurface;
